<template>
  <div>
    <div class="content">
      <img
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/07824e86c2a0446c06a6e0921cb63ac3.jpg"
      />
      <img
        class="btn"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d3d8f70383f98c6759cff5d2ac6856d8.png"
        @click="bindClick"
        alt=""
      />
    </div>
    <van-overlay :show="showOverlay" z-index="3">
      <div class="wrapper" @click.stop>
        <QuestinInfo @cancel="bindCancel" @submit="bindSubmit" />
      </div>
    </van-overlay>
  </div>
</template>
<script>
import QuestinInfo from './components/question-info.vue'
export default {
  components: {
    QuestinInfo
  },
  data() {
    return {
      showOverlay: false,
      isClickedBtn: false, //按钮是否被点击过
      submiting: false
    }
  },
  mounted() {
    setTimeout(() => {
      if (!this.isClickedBtn) {
        this.showOverlay = true
      }
    }, 5000)
  },
  methods: {
    bindClick() {
      this.isClickedBtn = true
      this.showOverlay = true
    },
    bindCancel() {
      this.showOverlay = false
    },
    bindSubmit(questionData) {
      if (this.submiting) {
        return
      }
      this.submiting = true
      let params = questionData
      params = Object.assign(params, this.$route.query)
      console.log(params)
      this.$http
        .postApp('api/v1/HugeEngine/add', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$toast('提交成功')
            this.bindCancel()
            setTimeout(() => {
              this.$router.push('/dy-add-customer')
            }, 300)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.$toast('异常错误')
        })
        .finally(() => {
          this.submiting = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  img {
    width: 100%;
    height: auto;
  }

  .btn {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 2;
  }
}
.wrapper {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
